import { ProfessionalTypeEnum } from '../../../app/interfaces/promptuary.interface';

export const specialtyOptions = [
	{ label: 'Coaching', value: ProfessionalTypeEnum.coach },
	{ label: 'Nutrição', value: ProfessionalTypeEnum.nutritionist },
	{ label: 'Psicanálise', value: ProfessionalTypeEnum.psychoanalyst },
	{ label: 'Psicologia', value: ProfessionalTypeEnum.psychologist },
	{ label: 'Psiquiatria', value: ProfessionalTypeEnum.psychiatrist },
	{ label: 'Terapias', value: ProfessionalTypeEnum.therapist },
	{ label: 'Outros', value: ProfessionalTypeEnum.others },
];
